import * as tslib_1 from "tslib";
import { AGALTokenizer } from "../aglsl/AGALTokenizer";
import { AGLSLParser } from "../aglsl/AGLSLParser";
import { OpCodes } from "../flash/OpCodes";
import { GLESAssetBase } from "./GLESAssetBase";
import { GLESConnector } from "./GLESConnector";
import { Byte32Array } from "@awayjs/core";
var ProgramGLES = (function (_super) {
    tslib_1.__extends(ProgramGLES, _super);
    function ProgramGLES(context, gl, id) {
        var _this = _super.call(this, context, id) || this;
        _this._uniforms = [[], [], []];
        _this._attribs = [];
        return _this;
        //console.log("awayjs created program with id "+ id);
        // this._gl = gl;
        // this._program = this._gl.createProgram();
    }
    ProgramGLES.prototype.upload = function (vertexProgram, fragmentProgram) {
        //detect whether highp can be used
        var vertexPrecision = (this._gl.getShaderPrecisionFormat(this._gl.VERTEX_SHADER, this._gl.HIGH_FLOAT).precision != 0) ? "highp" : "mediump";
        var fragmentPrecision = (this._gl.getShaderPrecisionFormat(this._gl.FRAGMENT_SHADER, this._gl.HIGH_FLOAT).precision != 0) ? "highp" : "mediump";
        var vertexString = ProgramGLES._aglslParser.parse(ProgramGLES._tokenizer.decribeAGALByteArray(vertexProgram), vertexPrecision);
        var fragmentString = ProgramGLES._aglslParser.parse(ProgramGLES._tokenizer.decribeAGALByteArray(fragmentProgram), fragmentPrecision);
        //(String.fromCharCode(OpCodes.uploadProgram)+""+this.id + "###"+vertexString +  "###" + fragmentString + "#END");
        var newSendbytes = new Byte32Array();
        newSendbytes.writeInt(1); //tells cpp that this is a create-bytes chunk
        newSendbytes.writeInt(OpCodes.uploadProgram);
        newSendbytes.writeInt(this.id);
        newSendbytes.writeUTFBytes(vertexString);
        newSendbytes.writeUTFBytes(fragmentString);
        newSendbytes.bytePosition = 0;
        var localInt32View = new Int32Array(newSendbytes.byteLength / 4);
        newSendbytes.readInt32Array(localInt32View);
        GLESConnector.gles.sendGLESCommands(localInt32View.buffer);
    };
    ProgramGLES.prototype.getUniformLocation = function (programType, index) {
        if (index === void 0) { index = -1; }
        // if (this._uniforms[programType][index + 1] != null)
        // 	return this._uniforms[programType][index + 1];
        //
        // var name:string =  (index == -1)? ProgramGLES._uniformLocationNameDictionary[programType] : ProgramGLES._uniformLocationNameDictionary[programType] + index;
        // return (this._uniforms[programType][index + 1] = this._gl.getUniformLocation(this._program, name));
        return null;
    };
    //
    // public getUniformLocation(programType:number, index:number):WebGLUniformLocation
    // {
    // 	if (this._uniforms[programType][index] != null)
    // 		return this._uniforms[programType][index];
    //
    // 	return (this._uniforms[programType][index] = this._gl.getUniformLocation(this._program, ProgramGLES._uniformLocationNameDictionary[programType] + index));
    // }
    ProgramGLES.prototype.getAttribLocation = function (index) {
        // if (this._attribs[index] != null)
        // 	return this._attribs[index];
        //
        // return (this._attribs[index] = this._gl.getAttribLocation(this._program, "va" + index));
        return 0;
    };
    ProgramGLES.prototype.dispose = function () {
        //this._context.addStream(String.fromCharCode(OpCodes.disposeProgram)+""+ this.id);
        this._context._createBytes.writeInt(OpCodes.disposeProgram);
        this._context._createBytes.writeInt(this.id);
        //GLESConnector.gles.disposeProgram(this.id);
        // this._gl.deleteProgram(this._program);
    };
    ProgramGLES.prototype.focusProgram = function () {
        //GLESConnector.gles.focusProgram(this.id);
        // this._gl.useProgram(this._program);
    };
    Object.defineProperty(ProgramGLES.prototype, "glProgram", {
        get: function () {
            return this._program;
        },
        enumerable: true,
        configurable: true
    });
    return ProgramGLES;
}(GLESAssetBase));
export { ProgramGLES };
ProgramGLES._tokenizer = new AGALTokenizer();
ProgramGLES._aglslParser = new AGLSLParser();
ProgramGLES._uniformLocationNameDictionary = ["fc", "fs", "vc"];



// WEBPACK FOOTER //
// ../dist/lib/gles/ProgramGLES.js